const ThemeName = Object.freeze({
    light: 'light',
    dark: 'dark',
    system: 'system',
});

export default ThemeName;